module.exports = __webpack_public_path__ + "assets/img/cutule.48fa3fad.png";